(() => {
  const initParallel = (root) => {
    if (!root || root.dataset.parallelReady === 'true') return;
    root.dataset.parallelReady = 'true';
    root.classList.add('is-enhanced');

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...root.querySelectorAll('[data-parallel-reveal]')];

    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach((node) => node.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach((node) => observer.observe(node));
    }

    root.querySelectorAll('video[autoplay]').forEach((video) => {
      video.muted = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });

    root.querySelectorAll('[data-parallel-rail]').forEach((rail) => {
      const track = rail.querySelector('[data-parallel-track]');
      const prev = rail.querySelector('[data-parallel-prev]');
      const next = rail.querySelector('[data-parallel-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const card = track.querySelector('.parallel-card');
        if (!card) return track.clientWidth;
        return card.getBoundingClientRect().width + 16;
      };

      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({ left: event.key === 'ArrowLeft' ? -step() : step(), behavior: reduced ? 'auto' : 'smooth' });
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-parallel-root]').forEach(initParallel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
